import { createSlice } from "@reduxjs/toolkit";

const DisconnectBOCOnlineFunctionsServiceSlice = createSlice({
    name: 'DisconnectBOCOnlineFunctionsService',
    initialState: {
        loading: false,
        DisconnectBOCOnlineFunctionsService: null,
        error: null,
        success: false
    },
    reducers: {
        fetchDisconnectBOCOnlineFunctionsServiceRequest(state) {
            state.loading = true;
            state.error = null;
        },
        fetchDisconnectBOCOnlineFunctionsServiceSuccess(state, action) {
            state.loading = false;
            state.success = true;
            state.DisconnectBOCOnlineFunctionsService = action.payload;
        },
        fetchDisconnectBOCOnlineFunctionsServiceFailure(state, action) {
            state.loading = false;
            state.success = false;
            state.error = action.payload;
        },
        fetchDisconnectBOCOnlineFunctionsServiceReset(state) {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.DisconnectBOCOnlineFunctionsService = null;
        }
    }
});

export const {
    fetchDisconnectBOCOnlineFunctionsServiceRequest, 
    fetchDisconnectBOCOnlineFunctionsServiceSuccess, 
    fetchDisconnectBOCOnlineFunctionsServiceFailure,
    fetchDisconnectBOCOnlineFunctionsServiceReset
} = DisconnectBOCOnlineFunctionsServiceSlice.actions;

export default DisconnectBOCOnlineFunctionsServiceSlice.reducer;